export enum EOrganizationTypeCode {
  LAL = 'LAL',
  SITE = 'SITE',
  EXT = 'EXT',
  SYS = 'SYS',
  OTH = 'OTH',
  SPEC = 'SPEC',
  SUBC = 'SUBC',
}

export enum EOrganizationTypeId {
  LAL = 1,
  SITE = 2,
  EXT = 3,
  SYS = 4,
  OTH = 5,
  SPEC = 6,
  SUBC = 7,
}
